// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"UniversalAlertProvider_alertContainer__2qUlv"};